import COTTON_PATH from './apiPaths';

export const SESSION = '/apis/session';

// TODO: Remove linkedAccounts query param when removed from MW.
// The linkedAccounts query param indicates to MW that FE is ready for new linked accounts
export const MACAROON = '/apis/macaroon?linkedAccounts=true';

export const ACCOUNT = '/apis?xap=true&deviceOwnership=true';

export const SWAPS = '/apis/csp/account/me/devices/swap/orders';
export const SWAPS_ORDER = '/apis/csp/account/me/devices/swap/order';
export const SWAP_ELIGIBILITY = '/apis/csp/account/me/devices/swap/eligibility?owner=true';
export const HIC = '/apis/csp/account/me/hic';

export const DSM_DEVICES = '/apis/ssm/dsm/devices';
export const DSM_RETURNS = '/apis/ssm/dsm/returns';
export const DSM_LABEL = '/apis/ssm/dsm/returns/label/:id';
export const DSM_NEW_LABEL = '/apis/ssm/dsm/returns/:id';
export const CONSOLIDATED_OUTAGE_LOB = '/apis/ssm/outage/consolidated/lob';
export const ITG_RECOMMENDATIONS = '/apis/ssm/itg/recommendations';
export const OUTAGE = '/apis/ssm/outage';

export const DEVICE_STATUS = '/apis/ssm/devices/status';
export const SIK_ORDER = '/apis/sik-order';
export const COTTON_SIK_ORDER = `/${COTTON_PATH}/apis/csp/account/me/sikOrders/latest`;
export const CMS_SUPPORT = '/apis/cms/support';
export const CSP_INTERNET_USAGE = '/apis/csp/account/me/services/internet/usage?filter=internet';
export const CSP_INTERNET_PLAN = '/apis/csp/account/me/services/internet/plan';


// Cotton apis
export const COTTON_SESSION = `/${COTTON_PATH}/apis/session`;
export const COTTON_ACCOUNT = `/${COTTON_PATH}/apis/account?xap=true&deviceOwnership=true`;

export const COTTON_MACAROON = `/${COTTON_PATH}/apis/macaroon?linkedAccounts=true`;

export const COTTON_SWAPS = `/${COTTON_PATH}/apis/csp/account/me/devices/swap/orders`;
export const COTTON_SWAPS_ORDER = `/${COTTON_PATH}/apis/csp/account/me/devices/swap/order`;
export const COTTON_SWAP_ELIGIBILITY = `/${COTTON_PATH}/apis/csp/account/me/devices/swap/eligibility?owner=true`;
export const COTTON_HIC = `/${COTTON_PATH}/apis/csp/account/me/hic`;

const DSM_PATH = `/${COTTON_PATH}/apis/ssm/dsm`;
export const COTTON_DSM_DEVICES = `${DSM_PATH}/devices`;
export const COTTON_DSM_RETURNS = `${DSM_PATH}/returns`;
export const COTTON_DSM_LABEL = `${DSM_PATH}/returns/label/:id`;
export const COTTON_DSM_NEW_LABEL = `${DSM_PATH}/returns/:id`;
export const COTTON_OUTAGE = `/${COTTON_PATH}/apis/v1/ssm/outage`;

export const COTTON_DISCONNECT = `/${COTTON_PATH}/oauth/v1/disconnect`;

export const COTTON_V1_SESSION = `/${COTTON_PATH}/apis/v1/session`;
export const COTTON_V1_ACCOUNT = `/${COTTON_PATH}/apis/v1/account?xap=true&deviceOwnership=true`;

const DSM_V1_PATH = `/${COTTON_PATH}/apis/v1/ssm/dsm`;
export const COTTON_V1_DSM_DEVICES = `${DSM_V1_PATH}/devices`;
export const COTTON_V1_DSM_RETURNS = `${DSM_V1_PATH}/returns`;
export const COTTON_V1_DSM_LABEL = `${DSM_V1_PATH}/returns/label/:id`;
export const COTTON_V1_DSM_NEW_LABEL = `${DSM_V1_PATH}/returns/:id`;
export const COTTON_CONSOLIDATED_OUTAGE_LOB = `/${COTTON_PATH}/apis/v1/ssm/outage/consolidated/lob`;

export const COTTON_DEVICE_STATUS = `/${COTTON_PATH}/apis/v1/ssm/devices/status`;
export const COTTON_ITG_RECOMMENDATIONS = `/${COTTON_PATH}/apis/v1/ssm/itg/recommendations`;
export const COTTON_CMS_SUPPORT = `/${COTTON_PATH}/apis/cms/support`;

// Outage / device-status endpoints (used by the devices-page Outage NBA)
export const SSM_OUTAGE = '/apis/ssm/outage';
export const SSM_DEVICE_STATUS = '/apis/ssm/devices/status';
export const CSP_HIC = '/apis/csp/account/me/hic';
export const COTTON_CSP_INTERNET_USAGE = `/${COTTON_PATH}/apis/csp/account/me/services/internet/usage?filter=internet`;
export const COTTON_CSP_INTERNET_PLAN = `/${COTTON_PATH}/apis/csp/account/me/services/internet/plan`;
